import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { PhoneInput } from '@/components/ui/phone-input'
import type { CoBorrowerFormValues } from '@/types/borrower-prescreen-dto'

type CoBorrowerFieldsProps = {
  value: CoBorrowerFormValues
  onChange: (next: CoBorrowerFormValues) => void
  disabled?: boolean
}

export function CoBorrowerFields({ value, onChange, disabled }: CoBorrowerFieldsProps) {
  const set = (field: keyof CoBorrowerFormValues, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue })
  }

  return (
    <div className="space-y-4 rounded-lg border p-4">
      <p className="text-sm font-medium">Co-borrower information</p>
      <div>
        <Label htmlFor="coEmail">Co-borrower email *</Label>
        <Input
          id="coEmail"
          type="email"
          value={value.email}
          onChange={(e) => set('email', e.target.value)}
          required
          disabled={disabled}
        />
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-4">
          <Label htmlFor="coFirstName">First name *</Label>
          <Input
            id="coFirstName"
            value={value.firstName}
            onChange={(e) => set('firstName', e.target.value)}
            required
            disabled={disabled}
          />
        </div>
        <div className="col-span-2">
          <Label htmlFor="coMiddleName">Middle</Label>
          <Input
            id="coMiddleName"
            value={value.middleName || ''}
            onChange={(e) => set('middleName', e.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="col-span-4">
          <Label htmlFor="coLastName">Last name *</Label>
          <Input
            id="coLastName"
            value={value.lastName}
            onChange={(e) => set('lastName', e.target.value)}
            required
            disabled={disabled}
          />
        </div>
        <div className="col-span-2">
          <Label htmlFor="coSuffix">Suffix</Label>
          <Input
            id="coSuffix"
            value={value.suffix || ''}
            onChange={(e) => set('suffix', e.target.value)}
            disabled={disabled}
          />
        </div>
      </div>
      <div>
        <Label htmlFor="coPhone">Phone number *</Label>
        <PhoneInput
          id="coPhone"
          value={value.phoneNumber}
          onChange={(phone) => set('phoneNumber', phone)}
          required
          disabled={disabled}
        />
      </div>
    </div>
  )
}

const emptyCoBorrower = (): CoBorrowerFormValues => ({
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: ''
})

export { emptyCoBorrower }
